'use strict';

var _objectWithoutProperties = require("/Users/tranlong/Desktop/projects/vietlotonline/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var currify = require('currify');

var query = function query(a) {
  return document.querySelector("[data-name=\"".concat(a, "\"]"));
};

var setAttribute = currify(function (el, obj, name) {
  return el.setAttribute(name, obj[name]);
});
var set = currify(function (el, obj, name) {
  return el[name] = obj[name];
});
var not = currify(function (f, a) {
  return !f(a);
});

var isCamelCase = function isCamelCase(a) {
  return a != a.toLowerCase();
};

module.exports = function (name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var dataName = options.dataName,
      notAppend = options.notAppend,
      _options$parent = options.parent,
      parent = _options$parent === void 0 ? document.body : _options$parent,
      _options$uniq = options.uniq,
      uniq = _options$uniq === void 0 ? true : _options$uniq,
      restOptions = _objectWithoutProperties(options, ["dataName", "notAppend", "parent", "uniq"]);

  var elFound = isElementPresent(dataName);
  if (uniq && elFound) return elFound;
  var el = document.createElement(name);
  if (dataName) el.dataset.name = dataName;
  Object.keys(restOptions).filter(isCamelCase).map(set(el, options));
  Object.keys(restOptions).filter(not(isCamelCase)).map(setAttribute(el, options));
  if (!notAppend) parent.appendChild(el);
  return el;
};

module.exports.isElementPresent = isElementPresent;

function isElementPresent(dataName) {
  if (!dataName) return;
  return query(dataName);
}